export const PERMISSIONS = {
  editExperiment: 'edit_experiment',
  deleteExperiment: 'delete_experiment',
  createExperiment: 'create_experiment',
}
